import { SuretyAccountId } from "@inrev/common";
import { FC } from "react";
import { AccountProcessingBanner } from "./AccountProcessingBanner";
import { AccountReviewReasonsBanner } from "./AccountReviewReasonsBanner";

type AccountBannerSectionProps = {
	accountId: SuretyAccountId;
};

export const AccountBannerSection: FC<AccountBannerSectionProps> = ({ accountId }) => {
	return (
		<>
			<AccountProcessingBanner accountId={accountId} />
			<AccountReviewReasonsBanner accountId={accountId} />
		</>
	);
};
